

export default {
    totalPartsOrders: [],
    partsOrders: [],
    partsOrdersFiltered: [],

}
